import { createSelector } from 'reselect';
import mappings from './mappings';

export const combinedColumnsSelector = createSelector(
    state => state.webJobsDetails.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);

export const getLoading = state => (
    state.commodityJobsDetails.loading
);

export const getRows = state => (
    state.commodityJobsDetails.rows
);
